export function waitlist(state) {
    return state.waitlist;
}

export function isWaitlistDataLoaded(state) {
    return state.isWaitlistDataLoaded;
}

export function getWaitlistDropInCoachingSessionDialog(state) {
  return state.waitlistRegistrationDialog;
}

export function getWaitlistDropInCoachingSlot(state) {
  return state.waitlistDropInCoachingSlot;
}

export function getWaitlistDropInType(state) {
  return state.waitlistDropInType;
}
